import { validateEnumTranslations } from '../../safety_checks';

export const TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON = 'RESERVATION_DISCOUNT_REASON_';
export const TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE = 'RESERVATION_DISCOUNT_UNAVAILABLE_';

//⚠️IMPACT attention changer dans le fichier prisma l'enum ReservationDiscountKind
/** Origine d'une remise posée sur une réservation : libre depuis l'agenda, ou promotion (lot 2 Promotions). */
export enum ReservationDiscountKind {
  MANUAL = 'MANUAL',
  PROMOTION = 'PROMOTION',
}

//⚠️IMPACT attention changer dans le fichier prisma l'enum ReservationDiscountReason
/** Motif d'une remise libre : liste rapide de l'agenda. */
export enum ReservationDiscountReason {
  COMMERCIAL_GESTURE = 'COMMERCIAL_GESTURE',
  LOYALTY = 'LOYALTY',
  LATENESS = 'LATENESS',
  SERVICE_ISSUE = 'SERVICE_ISSUE',
  OTHER = 'OTHER',
}

/** Origine d'une ligne de remise du bloc Montant d'un rendez-vous (pas une colonne : calculée à la lecture). */
export enum ReservationAmountDiscountSource {
  /** Code promo saisi par le client dans le tunnel. */
  PROMO_CODE = 'PROMO_CODE',
  /** Remise posée par le pro (table `reservation_discount`). */
  MANUAL = 'MANUAL',
  /** Écart entre le total enregistré et le calcul des lignes : montant saisi à la main avant la refonte. */
  ADJUSTMENT = 'ADJUSTMENT',
  /** Promotion posée par le pro depuis l'agenda (lot 2) : son libellé, qui l'a posée, quand. */
  PROMOTION = 'PROMOTION',
}

/** Pourquoi aucune remise ne peut être posée sur une réservation. */
export enum ReservationDiscountUnavailableReason {
  PRICE_NOT_FIRM = 'PRICE_NOT_FIRM',
  CANCELLED = 'CANCELLED',
  RIDE = 'RIDE',
  RECURRING = 'RECURRING',
  /** Total déjà à 0 : plus rien à remiser. */
  NOTHING_LEFT = 'NOTHING_LEFT',
  /**
   * Code promo réservé avant le socle des montants : sa remise n'est ni sur les lignes ni déduite du total
   * enregistré, et le reste figé du paiement l'a déjà retirée. Une remise ferait passer la réservation au
   * total après remise et retirerait le code une seconde fois du reste à encaisser.
   */
  LEGACY_PROMO = 'LEGACY_PROMO',
  /**
   * Prix final fixé à la main sur des lignes sans prix ferme (onglet « Promotion » seulement) : le moteur des
   * promotions juge des lignes au prix du catalogue, qu'il n'a pas ; une remise libre reste possible.
   */
  FIXED_PRICE = 'FIXED_PRICE',
}

export const ReservationDiscountReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON}${ReservationDiscountReason.COMMERCIAL_GESTURE}`]: 'Geste commercial',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON}${ReservationDiscountReason.LOYALTY}`]: 'Fidélité',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON}${ReservationDiscountReason.LATENESS}`]: 'Retard',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON}${ReservationDiscountReason.SERVICE_ISSUE}`]: 'Défaut de prestation',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON}${ReservationDiscountReason.OTHER}`]: 'Autre',
  },
};

validateEnumTranslations(
  ReservationDiscountReason,
  ReservationDiscountReasonTranslation,
  TRANSLATE_KEY_RESERVATION_DISCOUNT_REASON,
  true,
);

/** Pourquoi le bloc Montant ne propose pas « Ajouter une remise » (indication sous le bloc). */
export const ReservationDiscountUnavailableReasonTranslation = {
  'fr-FR': {
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.PRICE_NOT_FIRM}`]:
      'Pas de remise tant que le prix n’est pas fixé : choisissez une formule à prix ferme, ou renseignez le prix final.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.CANCELLED}`]:
      'Rendez-vous annulé : plus de remise possible.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.RIDE}`]:
      'Une course garde sa propre modification de prix.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.RECURRING}`]:
      'Une série récurrente partage une seule réservation : pas encore de remise possible.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.NOTHING_LEFT}`]:
      'Le total est déjà à 0 : plus rien à remiser.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.LEGACY_PROMO}`]:
      'Réservé avec un code promo avant la mise à jour des montants : pas de remise possible, le code est déjà déduit du paiement.',
    [`${TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE}${ReservationDiscountUnavailableReason.FIXED_PRICE}`]:
      'Prix final fixé à la main : les promotions, calculées sur le prix des prestations, ne s’appliquent pas. Une remise libre reste possible.',
  },
};

validateEnumTranslations(
  ReservationDiscountUnavailableReason,
  ReservationDiscountUnavailableReasonTranslation,
  TRANSLATE_KEY_RESERVATION_DISCOUNT_UNAVAILABLE,
  true,
);
